import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { AsyncPaginate } from 'react-select-async-paginate';
import {
  useGetAllFormsShortCodeMutation,
  useGetAllTemplatesMutation,
  useGetJobCategoriesMutation,
  useGetGoogleLocationMutation,
  useListAllJobsMutation,
  useGetCompanyLocationsMutation,
  useGetAllInternalFormsShortCodeMutation,
  useListApplicationAllJobsMutation,
  useGetAllJobLevelStagesMutation,
  useGetOfferTemplatesMutation,
  useGetPipelineAsyncStagesMutation,
  // useGetAllHiringLocationsMutation,
  useAnalyticsListAllJobsMutation,
  useGetProductsChannelByTypeMutation,
  useListAllJobsWHiringPlanMutation,
  useGetJobHiringPlansMutation,
  useGetAllJobsTemplatesMutation,
} from '../../../features/job/jobApiSlice';
import {
  useGetCandidateApplicationMutation,
  useGetJobApplicationCandidatesMutation,
  // useGetJobPositionsMutation,
} from '../../../features/candidates/candidateApiSlice';
import {
  useGetTeamListingMutation,
  useGetCandidatesListMutation,
} from '../../../features/calender/eventsApiSlice';
import StyledSelectCss from '../styledComponents/StyledSelectCss';
import {
  useGetAllCompanyUsersMutation,
  useGetAllRolesMutation,
  useGetCompanyRolesMutation,
  useGetInterviewRolesMutation,
} from '../../../features/users/listing/userApiSlice';
import { useGetReasonsMutation } from '../../../features/Setting/Reasons/reasonApiSlice';
import { useGetDepartmentsMutation } from '../../../features/Setting/Departments/departmentApiSlice';
import { useGetStageTypesMutation } from '../../../features/Setting/pipelineTemplates/pipelineApiSlice';
import styled, { useTheme } from 'styled-components';
import { useGetAllGlobalCampaignsMutation } from '../../../features/campaigns/CampaignApiSlice';
import {
  useGetCandSourcesAsyncSelectMutation,
  useGetSourcesAsyncSelectMutation,
} from '../../../features/Setting/candidateSources/candidateSourcesApiSlice';
import { useGetAllQuestionMutation, } from '../../../features/kanban/AdministerChecks/assets/AdministerCheckApiSlice';
import {
  useGetApproversMutation,
  useGetHiringManagerListingMutation,
  useGetInterviewersListingMutation,
  useGetRecruiterListingMutation,
} from '../../../features/Setting/Approvers/ApproverSlice';
import {
  useGetAllHiringPlanListingMutation,
  useGetHiringListingMutation,
} from '../../../features/kanban/kanbanApiSlice';
import { useGetOptionTypesMutation } from '../../../features/ReInterviews/InterviewSliceApi';
import { useGetAsyncChildCompaniesListingMutation } from '../../../features/Setting/ChildCompanies/childCompaniesApiSlice';
import { useGetVideoProfilesMutation } from '../../../features/Setting/VideoProfiling/VideoProfileApiSlice';
import { useGetAllUserByRolesMutation } from '../../../features/Setting/TransferResponsibilities/TransferResponsiblitiesApiSlice';
import { useGetSupersetChartColumnsMutation,  useGetSupersetDashboardTabsMutation } from '../../../features/Reporting/reportingApiSlice';
import {
  useGetAuthorityApproversMutation,
  useGetAuthorityApprovalChainsListingMutation,
  useGetEligibleCampaignJobsMutation,
} from '../../../features/AuthorityToRecruit/authorityToRecruitApiSlice';
import { mapEligibleApproverFromApi } from '../../../features/AuthorityToRecruit/approvalChainMappers';

const AsyncSelect = ({
  placeholder = 'Select a form from Library',
  className,
  onSelect,
  value,
  type,
  position,
  CustomOptionLayout,
  icon,
  isEmpty,
  clearAfterSelect = false,
  excludeIds = [],
  styles: externalStyles,
  ...props
}) => {
  const [selectedValue, setSelectedValue] = useState(value);
  const themes = useTheme();
  const menuBackground = themes?.dark
    ? themes.surface || themes.selectBg
    : themes.white;
  useEffect(() => {
    if (props.isMulti && value) {
      setSelectedValue([...value]);
    } else if (!props?.isMulti) {
      if (value)
        setSelectedValue({
          ...value,
          label: value?.title || value?.label,
          value: value?.id || value?.value,
        });
      else {
        if (type === 'meetingTypes') setSelectedValue({});
        else setSelectedValue();
      }
    }
  }, [value]);
  const [getFormsShortCode] = useGetAllFormsShortCodeMutation();
  const [getTplStages] = useGetPipelineAsyncStagesMutation();
  const [getInternalForms] = useGetAllInternalFormsShortCodeMutation();
  const [getTemplates] = useGetAllTemplatesMutation();
  const [getLocation] = useGetGoogleLocationMutation();
  const [getCompanySaveLocation] = useGetCompanyLocationsMutation();
  const [getJobCategories] = useGetJobCategoriesMutation();
  const [getAllJobs] = useListAllJobsMutation();
  const [getAllJobswithHiringPlan] = useListAllJobsWHiringPlanMutation();
  const [getAnalyticsAllJobs] = useAnalyticsListAllJobsMutation();
  const [getAllApplicationJobs] = useListApplicationAllJobsMutation();
  const [getCandidateApplications] = useGetCandidateApplicationMutation();
  const [getJobApplications] = useGetJobApplicationCandidatesMutation();
  const [getJobPositions] = useGetAllHiringPlanListingMutation();
  const [getJobHiringPlans] = useGetJobHiringPlansMutation();
  const [getSupersetChartColumns] = useGetSupersetChartColumnsMutation();
  const [getSupersetDashboardTabs] = useGetSupersetDashboardTabsMutation();
  const [getHiringListing] = useGetHiringListingMutation();
  const [getTeamListing] = useGetTeamListingMutation();
  const [getHiringManagerListing] = useGetHiringManagerListingMutation();
  const [getCandidatesList] = useGetCandidatesListMutation();
  const [getRoles] = useGetAllRolesMutation();
  const [getCompanyRoles] = useGetCompanyRolesMutation();
  const [getInterviewRoles] = useGetInterviewRolesMutation();
  const [getUsers] = useGetAllCompanyUsersMutation();
  const [getUsersByRoles] = useGetAllUserByRolesMutation();
  const [jobStages] = useGetAllJobLevelStagesMutation();
  const [getRecruiterListing] = useGetRecruiterListingMutation();
  const [getInterviewersListing] = useGetInterviewersListingMutation();
  const [getReasons] = useGetReasonsMutation();
  const [getOfferTemplate] = useGetOfferTemplatesMutation();
  const [getDepartments] = useGetDepartmentsMutation();
  const [getStageTypes] = useGetStageTypesMutation();
  const [getAllGlobalCampaigns] = useGetAllGlobalCampaignsMutation();
  const [getAllChannels] = useGetProductsChannelByTypeMutation();
  const [getSources] = useGetSourcesAsyncSelectMutation();
  const [candSource] = useGetCandSourcesAsyncSelectMutation();
  const [getAllQuestions] = useGetAllQuestionMutation();
  const [getApprovers] = useGetApproversMutation();
  const [getAuthorityApprovers] = useGetAuthorityApproversMutation();
  const [getEligibleCampaignJobs] = useGetEligibleCampaignJobsMutation();
  const [getAuthorityApprovalChainsListing] =
    useGetAuthorityApprovalChainsListingMutation();
  // const [getHiringLoc] = useGetAllHiringLocationsMutation();
  const [getAllChildCompanies] = useGetAsyncChildCompaniesListingMutation();
  const [getAllVideoProfiles] = useGetVideoProfilesMutation();
  const [getAllJobsTemplates] = useGetAllJobsTemplatesMutation();

  const [getMeetingTypes] = useGetOptionTypesMutation();

  const sortTypes = [
    'Internalforms',
    'forms',
    'jobs',
    'analyticsJobs',
    'OfferTempJobCreation',
    'eventTeamwithIcon',
    'roles',
    'interviewRoles',
    'users',
    'usersByRoles',
    'eventTeam',
    'locations',
    'rejectionReasons',
    'videoProfiles',
    'jobTemplates',
  ];
  const loadMoreTypes = [
    'candidates',
    'companyRoles',
    'eventTeam',
    'eventTeamwithIcon',
    'rejectionReasons',
    'searchLocation',
    'campaigns',
    'jobNameForcampaigns',
    'channels',
    'froms',
    'hiringManager',
    'recruiters',
    'interviewers',
    'approvers',
    'childCompanies',
    'videoProfiles',
    'usersByRoles',
    'authority_approval_chains',
    'jobTemplates',
  ];
  const getApiToCall = (type) => {
    switch (type) {
      // case 'hiringLocation':
      //   return getHiringLoc;
      case 'Internalforms':
        return getInternalForms;
      case 'charts':
          return getSupersetChartColumns;
      case 'dashboards':
          return getSupersetChartColumns;
      case 'tabs' :
            return getSupersetDashboardTabs
      case 'forms':
        return getFormsShortCode;
      case 'campaigns':
        return getAllGlobalCampaigns;
      case 'jobNameForcampaigns':
        return getAllGlobalCampaigns;
      case 'channels':
        return getAllChannels;
      case 'jobCategories':
        return getJobCategories;
      case 'gapi':
        return getLocation;
      case 'searchLocation':
        return getLocation;
      case 'templateLocation':
        return getLocation;
      case 'locations':
        return getCompanySaveLocation;
      case 'companyLocation':
        return getLocation;
      case 'jobs':
        return getAllJobs;
      case 'jobsWithHiringPlan':
        return getAllJobswithHiringPlan;
      case 'analyticsJobs':
        return getAnalyticsAllJobs;
      case 'rejectionReasons':
        return getReasons;
      case 'recruiters':
        return getRecruiterListing;
      case 'interviewers':
        return getInterviewersListing;
      case 'applicationjobs':
        return getAllApplicationJobs;
      case 'candSources':
        return candSource;
      case 'meetingTypes':
        return getMeetingTypes;
      case 'application':
        return getCandidateApplications;
      case 'jobApplication':
        return getJobApplications;
      case 'jobPositions':
        return getJobPositions;
      case 'jobHiringPlans':
        return getJobHiringPlans;
      case 'hiringplans':
        return getHiringListing;
      case 'eventTeam':
        return getTeamListing;
      case 'eventTeamwithIcon':
        return getTeamListing;
      case 'hiringManager':
        return getHiringManagerListing;
      case 'approvers':
        return getApprovers;
      case 'authority_approvers':
        return getAuthorityApprovers;
      case 'candidates':
        return getCandidatesList;
      case 'roles':
        return getRoles;
      case 'companyRoles':
        return getCompanyRoles;
      case 'interviewRoles':
        return getInterviewRoles;
      case 'users':
        return getUsers;
      case 'usersByRoles':
        return getUsersByRoles;
      case 'tplStages':
        return getTplStages;
      case 'jobStages':
        return jobStages;
      case 'departments':
        return getDepartments;
      case 'OfferTempJobCreation':
        return getOfferTemplate;
      case 'candidateSources':
        return getSources;
      case 'questionProfile':
        return getAllQuestions;
      case 'stageTypes':
        return getStageTypes;
      case 'childCompanies':
        return getAllChildCompanies;
      case 'videoProfiles':
        return getAllVideoProfiles;
      case 'jobTemplates':
        return getAllJobsTemplates;
      default:
        return getTemplates;
    }
  };

  async function loadOptions(search, loadedOptions, { page }) {
    if (type === 'authority_approval_chains') {
      try {
        const result = await getAuthorityApprovalChainsListing({
          page,
          perPage: 50,
          sort: 'createdAt',
          sortDir: 'DESC',
          ...props?.params,
          ...(search ? { query: search } : {}),
        }).unwrap();

        const options = (result?.options || []).map((option) => ({
          value: option.value,
          label: option.label,
          chain: option.chain,
        }));

        const totalCount = result?.totalCount ?? options.length;

        return {
          options,
          hasMore: loadedOptions.length + options.length < totalCount,
          additional: { page: page + 1 },
        };
      } catch (e) {
        return { options: [], hasMore: false };
      }
    }

    if (type === 'authority_approvers') {
      try {
        const result = await getAuthorityApprovers().unwrap();
        const source =
          result?.options ||
          (result?.chainApprovers || []).map(mapEligibleApproverFromApi);

        const query = (search || '').trim().toLowerCase();
        const excluded = new Set(excludeIds);
        const options = source
          .map((option) => ({
            value: option.value ?? option.id,
            label: option.label || option.name,
            firstName: option.firstName,
            lastName: option.lastName,
            name: option.name,
            role: option.role,
            companyRoles: option.companyRoles,
            jobTitle: option.jobTitle,
            accountCompanyRoles: option.accountCompanyRoles,
            accountRoles: option.accountRoles,
            signedUrl: option.signedUrl,
            email: option.email,
          }))
          .filter((option) => !excluded.has(option.value))
          .filter((option) => {
            if (!query) return true;
            const haystack = [
              option.label,
              option.name,
              option.role,
              option.jobTitle,
            ]
              .filter(Boolean)
              .join(' ')
              .toLowerCase();
            return haystack.includes(query);
          });

        return {
          options,
          hasMore: false,
          additional: { page: 1 },
        };
      } catch (e) {
        return { options: [], hasMore: false };
      }
    }

    if (type === 'authority_eligible_campaign_jobs') {
      try {
        const result = await getEligibleCampaignJobs({
          ...(search ? { query: search } : {}),
        }).unwrap();

        const options = (result?.options || []).map((option) => ({
          value: option.value,
          label: option.label,
          jobType: option.jobType,
          option: option.option || option,
        }));

        return {
          options,
          hasMore: false,
          additional: { page: 1 },
        };
      } catch (e) {
        return { options: [], hasMore: false };
      }
    }

    let param = {
      perPage: type === 'companyRoles' ? 10 : 5,
      page,
      ...(type !== 'companyRoles' && { query: search }),
      // sort: 'title', sortDir: 'ASC',

      ...(type === 'application' && {
        candidateId: props?.params?.candidateId,
      }),
        ...(type === 'dashboards' && {
        id: 'dashboard',
          page:page === 1 ? 0 : page - 1
      }),
       ...(type === 'charts' && {
        id: 'chart',
        page:page === 1 ? 0 : page - 1
      }),
       ...(type === 'tabs' && {
        id: props?.params?.tabId,
      }),
       
      ...(sortTypes.includes(type) && {
        sort:
          type === 'locations'
            ? 'postalCode'
            : type === 'rejectionReasons'
              ? 'text'
              : type === 'roles'
                ? 'name'
                : 'title',
        sortDir: 'ASC',
      }),
      ...(type === 'roles' && {
        ...props?.params,
      }),
      ...((type === 'jobApplication' || type === 'hiringplans') && {
        jobId: props.params?.jobId,
      }),
      ...(type === 'jobPositions' && {
        ...props?.params,
        jobId: props.params?.jobId,
      }),
      ...(type === 'jobHiringPlans' && {
        ...props?.params,
        id: props.params?.jobId,
      }),
      ...((type === 'jobs' ||
        type === 'videoProfiles' ||
        type === 'usersByRoles') && {
        ...props?.params,
      }),
    };
    if (type === 'jobStages') {
      param = { param, jobId: props?.jobId };
    }
    if (type === 'users') {
      param = { ...param, ...{ oooList: props?.oooList || false } };
    }
    // if (type === 'hiringLocation') {
    //   param = { jobId: props?.jobId };
    // }
    if (type === 'tplStages') {
      param = { param, tplId: props?.jobId };
    }
    if (type === 'meetingTypes') {
      param = { accountIds: props?.accountId.map((val) => val) };
    }
    if (type === 'childCompanies') {
      param = { ...param, statusId: props.statusId };
    }
    if (type === 'childCompanies') {
      param = { ...param, statusId: props.statusId };
    }
    if (type === 'channels') {
      param = { ...param, productType: 'ADVERTISING' };
    }

    try {
      let call = getApiToCall(type);
      const { data } = await call(param);
      
      const options = await data?.options?.map((option) => ({
        value: option.id,
        label: option.title,
        ...(type === 'Internalforms' && {
          createdAt: option.createdAt,
        }),
         ...(type === 'charts' && {
          value: option.value,
        label: option.label,
         chart:option
        }),
         ...(type === 'columns' && {
          value: option.id,
        label: option.slice_name,
         chart:option
        }),
         ...(type === 'tabs' && {
          value: option.value,
        label: option.label,
         chart:option
        }),
         ...(type === 'dashboards' && {
          value: option.value,
        label: option.label,
         dashboard:option
        }),
        ...(type === 'videoProfiles' && {
          value: option.id,
          label: option.title,
          shortCode: option.shortCode,
          name: option.name
        }),
        ...(type === 'users' && {
          roles: option.role,
          signedUrl: option.signedUrl,
        }),

        ...(type === 'candidateSources' && {
          value: option.value,
          label: { title: option.title, productType: option.productType },
        }),
        ...(type === 'candSources' && {
          value: option.value,
          label: { title: option.title, productType: option.productType },
        }),
        ...(type === 'meetingTypes' && {
          value: option?.value,
          label: { text: option?.label?.text, icon: option?.label?.icon },
        }),
        ...(type === 'searchLocation' && {
          value: option,
        }),
        ...(type === 'gapi' && {
          latitude: option.lat,
          longitude: option.lon,
          value: option.value,
        }),
        ...((type === 'templateLocation' || type === 'locations') && {
          town: option.town,
          postcode: option.postcode,
          value: option.value,
        }),
        ...(type === 'application' && { label: option?.job?.title }),
        // ...(type === 'jobs' && { label: option?.title, value: option?.value }),

        ...(type === 'eventTeam' && {
          label: option?.firstName + ' ' + option?.lastName,
          signedUrl: option.signedUrl,
        }),
        ...((type === 'hiringManager' ||
          type === 'approvers' ||
          type === 'authority_approvers' ||
          type === 'recruiters' ||
          type === 'interviewers') && {
          label: option?.firstName + ' ' + option?.lastName,
          signedUrl: option?.signedUrl,
          unBudgeted: option?.unBudgeted,
          budgeted: option?.budgeted,
        }),
        ...(type === 'eventTeamwithIcon' && {
          label: {
            text: option?.firstName + ' ' + option?.lastName,
            icon: option.signedUrl,
          },
          signedUrl: option.signedUrl,
          email: option?.email ?? '',
          accountId: option?.id,
        }),
        ...(type === 'applicationjobs' && {
          label: option?.label,
        }),
        ...(type === 'jobPositions' && {
          option: option,
        }),

        ...(type === 'jobHiringPlans' && {
          option: option,
          label: option.label,
        }),
        ...(type === 'jobs' && {
          value: option.id,
          label: option.title,
          option: option,
        }),
        ...(type === 'jobsWithHiringPlan' && {
          value: option.value,
          label: option.label,
          option: option,
        }),
        ...(type === 'usersByRoles' && {
          signedUrl: option.signedUrl,
          accountRoles: option.accountRoles,
        }),
        ...(type === 'hiringplans' && {
          startdate: option?.startDate,
          postions: option?.postions,
          ...option,
        }),
        ...(type === 'campaigns' && {
          value: option?.campaign?.id,
          label: option?.campaign?.campaignName,
        }),
        ...(type === 'jobNameForcampaigns' && {
          value: option?.campaign?.id,
          label: option?.campaign?.jobTitle,
        }),
        ...(type === 'candidates' && {
          label: `${option?.candidate?.firstName} ${option?.candidate?.lastName}`,
          value: option?.id,
        }),
        // ...(type === 'hiringLocation' && {
        //   label: `${option?.title}`,
        //   value: option.value,
        // }),
        ...(type === 'jobStages' && {
          label: option?.label,
          value: option.value,
        }),
        ...(type === 'OfferTempJobCreation' && {
          value: option?.value,
          label: option?.label,
          templatedata: option?.document,
        }),
        ...(type === 'interviewRoles' && {
          label: option.label,
          value: option.value,
        }),
      }));

      return {
        options: options || [],
        hasMore: loadedOptions.length + options.length < data?.total,
        ...(loadMoreTypes.includes(type) && {
          hasMore: loadedOptions.length + options.length < data?.totalCount,
        }),
        additional: {
          page: page + 1,
        },
      };
    } catch (e) {
      return {
        options: [],
        hasMore: false,
      };
    }
  }

  const customStyles = useMemo(() => {
    const getOptionBackground = (state) => {
      if (state.isSelected || state.isFocused) {
        return themes?.dark ? themes.fieldLabelBg || themes.selectBg : themes.primaryLight;
      }
      return 'transparent';
    };

    const base = {
      menu: (provided) => ({
        ...provided,
        backgroundColor: menuBackground,
        borderRadius: 12,
        border: themes?.dark
          ? '1px solid rgba(255, 255, 255, 0.16)'
          : '1px solid rgba(13, 35, 73, 0.08)',
        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.15)',
        overflow: 'hidden',
      }),
      menuList: (provided) => ({
        ...provided,
        backgroundColor: menuBackground,
        padding: 10,
      }),
      menuPortal: (provided) => ({
        ...provided,
        zIndex: 20000,
      }),
      option: (provided, state) => ({
        ...provided,
        backgroundColor: getOptionBackground(state),
        borderRadius: props.borderRadius ? 10 : 8,
        padding: '10px 15px',
        color: themes?.dark ? themes.headingColor || '#e8e8e8' : themes.textColor,
        cursor: 'pointer',
      }),
      singleValue: (provided) => ({
        ...provided,
        color: themes?.dark ? themes.headingColor || '#e8e8e8' : provided.color,
      }),
      input: (provided) => ({
        ...provided,
        color: themes?.dark ? themes.headingColor : themes.textColor,
      }),
    };

    if (!externalStyles) return base;

    return Object.keys({ ...base, ...externalStyles }).reduce((merged, key) => {
      const baseFn = base[key];
      const extFn = externalStyles[key];
      if (!baseFn && !extFn) return merged;
      merged[key] = (provided, state) => {
        let next = provided;
        if (baseFn) next = baseFn(next, state);
        if (extFn) next = extFn(next, state);
        return next;
      };
      return merged;
    }, {});
  }, [themes, menuBackground, externalStyles, props.borderRadius]);

  const handleChange = useCallback(
    (val) => {
      if (onSelect) {
        onSelect(val);
        if (clearAfterSelect) {
          setSelectedValue(null);
        }
      } else {
        setSelectedValue(val);
      }
    },
    [onSelect, clearAfterSelect],
  );

  const optionalData = (option) =>
    CustomOptionLayout ? CustomOptionLayout(option) : option?.label;

  return (
    <CustomAsync className={icon && icon ? 'analytics' : ''}>
      {icon && icon}
      <StyledSelectCss>
        <AsyncPaginate
          menuPlacement={position}
          menuPortalTarget={
            typeof document !== 'undefined' ? document.body : null
          }
          menuPosition="fixed"
          value={selectedValue}
          onChange={handleChange}
          styles={customStyles}
          placeholder={placeholder}
          loadOptions={loadOptions}
          debounceTimeout={500}
          getOptionLabel={(option) => optionalData(option)}
          cacheUniqs={[
            props.params?.jobId ||
              props.params?.childCompanyId ||
              props.params?.parentCompanyId ||
              props?.accountId,
          ]}
          theme={(theme) => ({
            ...theme,
            borderRadius: 10,
            colors: {
              ...theme.colors,
              neutral0: menuBackground,
              neutral5: menuBackground,
              neutral10: menuBackground,
              neutral20: menuBackground,
              neutral30: themes?.dark ? themes.headingColor : themes.textColor,
              neutral40: themes?.dark ? themes.headingColor : themes.textColor,
              neutral50: themes?.dark ? themes.headingColor : themes.textColor,
              neutral60: themes?.dark ? themes.headingColor : themes.textColor,
              neutral70: themes?.dark ? themes.headingColor : themes.textColor,
              neutral80: themes?.dark ? themes.headingColor : themes.textColor,
              neutral90: themes?.dark ? themes.headingColor : themes.textColor,
              primary25: themes?.dark ? themes.bodyColor : themes.lightHover,
              primary50: themes?.dark ? themes.bodyColor : themes.primaryLight,
            },
          })}
          style={{ width: 100 }}
          className={`async-select ${props.isValid ? 'is-valid' : ''} ${props.isLightPink ? 'is-light-pink' : ''
            } ${props.isInvalid ? 'is-invalid' : ''}
          ${props.analytics ? 'analytics' : ''} ${props.disabled ? 'disabled' : ''
            } ${className ?? ''}`}
          additional={{
            page: 1,
          }}
          {...props}
        />
      </StyledSelectCss>
    </CustomAsync>
  );
};

const CustomAsync = styled.div`
  &.analytics {
    > div {
      width: 100%;
    }
    display: flex;
    align-items: center;
    cursor: pointer;
    background: ${({ theme }) => theme.white};
    font-size: 14px;
    border: 1px solid ${({ theme }) => theme.borderLight};
    border-radius: 8px;
    width: 170px;
    max-width: 170px;
    margin-top: 5px;
    height: 30px;
    z-index: 999;
    padding: 0px;
    padding-block: 0px;
    &:hover,
    &:active,
    &:focus {
      border: 1px solid ${({ theme }) => theme.inputBorder};
      background: ${({ theme }) => theme.primaryLight};
      color: ${({ theme }) => theme.primary};
      box-shadow: none;
    }
  }
`;

export default AsyncSelect;